import { get } from "lodash";

class ContentfulEntry {
    
    static default = {
        id: ""
    }

	static fields = (contentfulEntry: any) => get(contentfulEntry, "fields", {});

	static sys = (contentfulEntry: any) => get(contentfulEntry, "sys", {});

	static id = (contentfulEntry: any) => {
		const sys = ContentfulEntry.sys(contentfulEntry);
		const id = get(sys, "id", ContentfulEntry.default.id);
		return id;
	};
}

export default ContentfulEntry;
